import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getProjects, deleteProject } from "../actions/projectActions";

import { getCompanies } from "../actions/companyActions";

import { getCompaniesOfEmployee } from "../actions/employeeActions";

import {
  Grid,
  TextField,
  Button,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";

import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class ProjectList extends Component {
  state = {
    projects: [],

    cityZipcode: "",
    companies: [],
    beginDate: moment(),
    endDate: moment().add(7, "days"),

    optionCompanies: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  refreshData() {
    this.setState({ optionCompanies: [], projects: [] });

    if (credentials.user.isAdmin) {
      this.props.getCompanies().then((response) => {
        this.setState({ optionCompanies: response });
      });
    } else if (credentials.user.isSeniorEmployee) {
      this.props
        .getCompaniesOfEmployee(credentials.user.email, true)
        .then((optionCompanies) => this.setState({ optionCompanies }));
    }

    this.props
      .getProjects({
        cityZipcode: this.state.cityZipcode,
        companies: this.props.company
          ? [this.props.company]
          : this.state.companies,
        beginDate: this.state.beginDate,
        endDate: this.state.endDate,
        include: ["company"],
      })
      .then((projects) => {
        this.setState({ projects });
      });
  }

  deleteProject(projectId) {
    this.props.deleteProject(projectId).then(() => {
      this.setState({
        projects: this.state.projects.filter((p) => p.id != projectId),
      });
    });
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCompanyChange = (event) =>
    this.setState({ companies: event.target.value });

  render() {
    return (
      <Fragment>
        <Grid container spacing={3}>
          {(credentials.user.isAdmin || credentials.user.isSeniorEmployee) &&
            !this.props.company && (
              <Grid item xs={12} sm={6}>
                <InputLabel htmlFor="companies">Bedrijven</InputLabel>
                <Select
                  id="companies"
                  name="companies"
                  multiple
                  value={this.state.companies}
                  onChange={this.handleCompanyChange}
                  fullWidth
                >
                  {this.state.optionCompanies.map((company) => (
                    <MenuItem
                      key={company.email}
                      value={company.email}
                      style={{
                        fontWeight:
                          this.state.companies.indexOf(company.email) === -1
                            ? "normal"
                            : "500",
                      }}
                    >
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}

          <Grid
            item
            xs={12}
            sm={
              credentials.user.type === "COMPANY" || this.props.company ? 12 : 6
            }
          >
            <TextField
              id="cityZipcode"
              name="cityZipcode"
              label="Stad/postcode"
              value={this.state.cityZipcode}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="beginDate"
              name="beginDate"
              label="Datum vanaf *"
              value={this.state.beginDate}
              format={"L"}
              onChange={(m) => this.setState({ beginDate: m })}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id="endDate"
              name="endDate"
              label="Datum tot en met *"
              value={this.state.endDate}
              format={"L"}
              onChange={(m) => this.setState({ endDate: m })}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.refreshData()}
            >
              Zoek
            </Button>
          </Grid>
        </Grid>

        <DataListWithSearchFilter
          data={this.state.projects.map((project) => {
            return {
              id: project.id,
              title: `${project.name} ${
                project.company ? `(${project.company.name})` : ""
              }`,
              subtitle: `${moment(project.beginDate).format(
                "DD-MM-YYYY HH:mm",
              )} tot ${moment(project.endDate).format("DD-MM-YYYY HH:mm")} in ${
                project.city
              }`,
              onClick: () =>
                (window.location.href = `/company/${project.companyEmail}/project/${project.id}`),
              ctxMenu: [
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/project/${project.id}/update`),
                },
                {
                  label: "Verwijderen",
                  action: () => this.deleteProject(project.id),
                  confirm: true,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

ProjectList.propTypes = {
  getProjects: PropTypes.func.isRequired,
  deleteProject: PropTypes.func.isRequired,
  getCompanies: PropTypes.func.isRequired,
  getCompaniesOfEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
  company: PropTypes.string,
};

const mapStateToProps = (state) => ({
  successMessage: state.project.deleteProject.successMessage,
  errorMessage: state.project.deleteProject.errorMessage,
  isFetching:
    state.project.deleteProject.isFetching ||
    state.project.getProjects.isFetching ||
    state.company.getCompanies.isFetching ||
    state.employee.getCompaniesOfEmployee.isFetching,
});

export default connect(mapStateToProps, {
  getProjects,
  deleteProject,
  getCompanies,
  getCompaniesOfEmployee,
})(ProjectList);



// WEBPACK FOOTER //
// ./src/components/ProjectList.js